import React from 'react';

import { Blockquote, Flex, Float, For, Heading } from '@chakra-ui/react';

import './styles/TestimonialsComponent.css';
import TestimonialCard from './TestimonialCard';

function TestimonialsComponent() {

    let testimonials = [
        {
            company: "Citadel",
            role: "Software Engineer",
            initial: {
                base: "225k",
                rsus: "0k",
                annual_bonus: "225k",
                sign_on_bonus: "75k",
            },
            final: {
                base: "250k",
                rsus: "0k",
                annual_bonus: "250k",
                sign_on_bonus: "100k",
            },
            total_increase: "75k"
        },
        {
            company: "Meta",
            role: "Software Engineer",
            initial: {
                base: "200k",
                rsus: "600k",
                annual_bonus: "30k",
                sign_on_bonus: "35k",
            },
            final: {
                base: "220k",
                rsus: "750k",
                annual_bonus: "33k",
                sign_on_bonus: "50k",
            },
            total_increase: "188k"
        },
        {
            company: "Intuit",
            role: "Software Engineer",
            initial: {
                base: "125k",
                rsus: "75k",
                annual_bonus: "0k",
                sign_on_bonus: "10k",
            },
            final: {
                base: "145k",
                rsus: "125k",
                annual_bonus: "0k",
                sign_on_bonus: "12k",
            },
            total_increase: "72k"
        }
    ];

    return (
        // Need to use this trick so we jump to the offset of navigation bar
        <div style={{
            paddingTop: '69px',
            marginTop: '-69px',
        }}
        id='testimonials'>
            {/* Desktop only view */}
            <Flex className='testimonial_component__parent' direction='column' gap='8'>
                <Heading color='black' fontWeight='bold' size='5xl'>
                    See what our customers are saying
                </Heading>
                <Flex gap='8' className='testimonial_component__cards' style={{marginTop: '40px'}}>
                    <For each={testimonials}>
                        {(item, index) => (
                            <TestimonialCard details={item} key={index}/>
                        )}
                    </For>
                </Flex>
                <Flex justify='center' style={{marginTop: '40px'}}>
                    <Blockquote.Root variant='plain'>
                        <Float color='black' placement="top-start" offsetY="2">
                            <Blockquote.Icon />
                        </Float>
                        <Blockquote.Content color='black' fontSize='xl'>
                            This was the best investment I've ever spent
                        </Blockquote.Content>
                        <Blockquote.Caption color='black'>
                            — <cite>Citadel Software Engineer</cite>
                        </Blockquote.Caption>
                    </Blockquote.Root>
                </Flex>
            </Flex>

            {/* Mobile only view */}
            <Flex className='testimonial_component__mobile_parent' direction='column' gap='8'>
                <Heading color='black' fontWeight='bold' size='4xl'>
                    See what our customers are saying
                </Heading>
                <Flex gap='8' direction='column' className='testimonial_component__cards' style={{marginTop: '25px'}}>
                    <For each={testimonials}>
                        {(item, index) => (
                            <TestimonialCard details={item} key={index}/>
                        )}
                    </For>
                </Flex>
                <Flex justify='center' style={{marginTop: '30px'}}>
                    <Blockquote.Root variant='plain'>
                        <Float color='black' placement="top-start" offsetY="2">
                            <Blockquote.Icon />
                        </Float>
                        <Blockquote.Content color='black' fontWeight='bold' fontSize='lg'>
                            This was the best investment I've ever spent
                        </Blockquote.Content>
                        <Blockquote.Caption color='black'>
                            — <cite>Citadel Software Engineer</cite>
                        </Blockquote.Caption>
                    </Blockquote.Root>
                </Flex>
            </Flex>
        </div>
    );
}

export default TestimonialsComponent;
